import styled from "styled-components";

import { colors } from "@/Utils";

export interface Margin {
  margin?: number;
  mrtop?: number;
  mrright?: number;
  mrbottom?: number;
  mrleft?: number;
}

export interface FontSize {
  fSize?: number;
}

export interface FontWeight {
  fweight?: number;
}

export interface Padding {
  padding?: number;
}

export interface Height {
  height?: number;
}

interface P1Props extends Padding, FontWeight, FontSize {
  fweight?: number;
  justifyContent?: string;
  alignItems?: string;
  display?: string;
  whiteSpace?: string;
  width?: number;
  fStyle?: string;
  isOpacity?: boolean;
}
export const P1 = styled("p")<P1Props & Margin & FontSize>`
  width: ${(props) => (props.width ? `${props.width}%` : "")};
  padding: ${(props) => (props.padding ? `${props.padding}px 0` : 0)};
  padding-left: 0;
  padding-right: 0;
  margin: ${(props) => (props.margin ? `${props.margin}px 0` : 0)};
  margin-left: ${(props) => (props.mrleft ? `${props.mrleft}px` : 0)};
  margin-top: ${(props) => (props.mrtop ? `${props.mrtop}px` : 0)};
  margin-bottom: ${(props) => (props.mrbottom ? `${props.mrbottom}px` : 0)};
  margin-right: ${(props) => (props.mrright ? `${props.mrright}px` : 0)};
  font-size: ${(props) => (props.fSize ? `${props.fSize}px` : "inherit")};
  font-weight: ${(props) => (props.fweight ? `${props.fweight}` : "inherit")};
  font-style: ${(props) => (props.fStyle ? `${props.fStyle}` : "normal")};
  justify-content: ${(props) => (props.justifyContent ? `${props.justifyContent}` : "unset")};
  align-items: ${(props) => (props.alignItems ? `${props.alignItems}` : "center")};
  color: ${(props) =>
    props.color
      ? `${props.color}`
      : props.theme.mode === "dark"
        ? colors.white
        : props.theme.mode === "light"
          ? colors.bodyMain
          : colors.white};
  display: ${(props) => (props.display ? props.display : "flex")};
  white-space: ${(props) => (props.whiteSpace ? props.whiteSpace : "normal")};
  opacity: ${(props) => (props.isOpacity ? "0.4" : "1")};
`;

interface H3Props extends Padding, Margin, FontWeight, FontSize {
  fWeight?: number;
}
export const H3 = styled("h3")<H3Props>`
  padding: ${(props) => (props.padding ? `${props.padding}px 0` : 0)};
  padding-left: 0;
  padding-right: 0;
  margin: ${(props) => (props.margin ? `${props.margin}px 0` : 0)};
  margin-left: ${(props) => (props.mrleft ? `${props.mrleft}px` : 0)};
  margin-top: ${(props) => (props.mrtop ? `${props.mrtop}px` : 0)};
  margin-bottom: ${(props) => (props.mrbottom ? `${props.mrbottom}px` : 0)};
  margin-right: ${(props) => (props.mrright ? `${props.mrright}px` : 0)};
  font-weight: ${(props) => (props.fWeight ? props.fWeight : 600)};
  font-size: ${(props) => (props.fSize ? `${props.fSize}px` : `${9}px`)};
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  color: ${(props) =>
    props.color
      ? `${props.color}`
      : props.theme.mode === "dark"
        ? colors.white
        : props.theme.mode === "light"
          ? colors.bodyMain
          : colors.white};
  letter-spacing: 0.02px;
`;

interface H1Props extends Margin, Padding, FontSize, FontWeight {}
export const H1 = styled("h1")<H1Props>`
  padding: ${(props) => (props.padding ? `${props.padding}px 0` : 0)};
  padding-left: 0;
  padding-right: 0;
  margin: ${(props) => (props.margin ? `${props.margin}px 0` : 0)};
  margin-left: ${(props) => (props.mrleft ? `${props.mrleft}px` : 0)};
  margin-top: ${(props) => (props.mrtop ? `${props.mrtop}px` : 0)};
  margin-bottom: ${(props) => (props.mrbottom ? `${props.mrbottom}px` : 0)};
  margin-right: ${(props) => (props.mrright ? `${props.mrright}px` : 0)};
  font-size: ${(props) => (props.fSize ? `${props.fSize}px` : `${9}px`)};
  font-weight: ${(props) => (props.fweight ? `${props.fweight}` : "inherit")};
  color: ${(props) =>
    props.color
      ? `${props.color}`
      : props.theme.mode === "dark"
        ? colors.white
        : props.theme.mode === "light"
          ? colors.bodyMain
          : colors.white};
`;

type SpacerProps = Height;
export const Spacer = styled("div")<SpacerProps>`
  display: flex;
  width: 100%;
  height: ${(props) => (props.height ? `${props.height}px` : `${0}px`)};
`;

interface SpanProps extends Margin, Padding, FontWeight, FontSize, Height {
  minHeight?: number;
  alignSelf?: string;
  pdtop?: number;
}
export const Span = styled("span")<SpanProps>`
  height: ${(props) => (props.height ? `${props.height}px` : "auto")};
  min-height: ${(props) => (props.minHeight ? `${props.minHeight}px` : "auto")};
  margin: ${(props) => (props.margin ? `${props.margin}px 0` : 0)};
  margin-left: ${(props) => (props.mrleft ? `${props.mrleft}px` : 0)};
  margin-top: ${(props) => (props.mrtop ? `${props.mrtop}px` : 0)};
  margin-bottom: ${(props) => (props.mrbottom ? `${props.mrbottom}px` : 0)};
  margin-right: ${(props) => (props.mrright ? `${props.mrright}px` : 0)};
  padding-top: ${(props) => (props.pdtop ? `${props.pdtop}px` : `${0}px`)};
  color: ${(props) =>
    props.color
      ? props.color
      : props.theme.mode === "dark"
        ? colors.white
        : props.theme.mode === "light"
          ? colors.black
          : colors.pink};
  font-size: ${(props) => (props.fSize ? `${props.fSize}px` : `${11}px`)};
  font-weight: ${(props) => (props.fweight ? `${props.fweight}` : "inherit")};
  font-stretch: normal;
  display: flex;
  align-self: ${(props) => (props.alignSelf ? `${props.alignSelf}` : "auto")};
  align-items: center;
`;
